namespace SorAraBul.Common.Functions {
    export function addAndUpdateCreditInfo(containerElement: JQuery) {
        Administration.UserCreditService.GetCredit({}, (resp) => {
            const existingBox = containerElement.find(".kredi-bilgi-kutusu");
            const htmlContent = `
                Kalan Krediniz: <strong>${resp.Credit}</strong> 
                <a href="/credit-purchase" class="kredi-satin-al-link">Satın Al</a>
            `;

            if (existingBox.length === 0) {
                $(`<div class="kredi-bilgi-kutusu">${htmlContent}</div>`)
                    .insertAfter(containerElement.find(".tool-buttons"));
            } else {
                existingBox.html(htmlContent);
            }
        });
    }
}